var _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint0_linear_4236_113099)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.25,
    y: 5,
    width: 1.5,
    height: 4,
    rx: 0.75,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.25,
    y: 9.5,
    width: 1.5,
    height: 1.5,
    rx: 0.75,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4236_113099",
    x1: 3,
    y1: 3,
    x2: 6.28652,
    y2: 14.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB74A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/Exclamation.34683639856e440b2d9c4e1cfde07daa.svg";
export { ForwardRef as ReactComponent };